import React from "react";

const steps = [
  {
    title: "Skill Diagnostic + Basic English",
    description: "Cari tahu dulu titik lemahmu. Lalu perkuat grammar & vocab dari dasar lewat 20 lesson terstruktur",
  },
  {
    title: "Kelas Intensif 4 Skill IELTS",
    description: "Live teaching, latihan harian, dan AI writing feedback,  fokus pada strategi real test yang terbukti",
  },
  {
    title: "Simulasi IELTS + Evaluasi",
    description: "Simulasi test di akhir program untuk melihat progres dan memastikan kesiapan skor kamu",
  },
];

const HowItWorksProduct2 = () => {
  return (
    <section className="st-howitworks-section overflow-x-clip">
      <div className="relative w-full">
        <div className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
          <div className="mx-auto grid w-full max-w-[1000px] gap-10 lg:grid-cols-[minmax(0,330px)_minmax(0,1fr)] lg:gap-16 xl:gap-20 justify-center">
        <div className="max-w-[320px] lg:pt-6">
          <h2 className="st-font-display text-[48px] leading-[0.9] sm:text-[60px] lg:text-[72px] xl:text-[84px]">
            <span className="italic st-howitworks-title">How it</span>{" "}
            <span className="st-howitworks-accent font-bold">Works</span>
            <span className="st-howitworks-title">?</span>
          </h2>

          <p className="st-font-body mt-8 text-[15px] leading-[1.45] st-howitworks-text sm:text-[16px] lg:text-[17px]">
            Proses belajar <strong className="font-extrabold st-howitworks-title">step-by-step</strong> dari <strong className="font-extrabold st-howitworks-title">basic</strong> sampai <strong className="font-extrabold st-howitworks-title">siap tes IELTS!</strong>
          </p>
        </div>

        <div className="relative pl-10 sm:pl-12 lg:pl-14">
          <div className="absolute left-6 top-3 bottom-2 w-px st-howitworks-line sm:left-7" aria-hidden="true" />

          <div className="space-y-10 sm:space-y-12 lg:space-y-14">
            {steps.map((step) => (
              <article key={step.title} className="relative">
                <span
                  className="absolute left-[-22px] top-[6px] h-3.5 w-3.5 rounded-full st-howitworks-dot sm:left-[-20px] md:left-[-27px] lg:left-[-34px] lg:top-[10px]"
                  aria-hidden="true"
                />

                <div className="max-w-[980px]">
                  <h3 className="st-font-body text-[20px] font-extrabold leading-[1.15] st-howitworks-accent sm:text-[26px] lg:text-[32px]">
                    {step.title}
                  </h3>

                  <p className="st-font-body mt-4 text-[15px] leading-[1.55] st-howitworks-text sm:text-[18px] lg:text-[22px]">
                    {step.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
        </div>
        </div>

        <div className="w-full overflow-hidden bg-[#F6CA2D] py-3">
          <div className="st-font-body max-w-none whitespace-nowrap text-center text-[26px] font-bold uppercase tracking-[0.02em] text-[#BB230B] sm:text-[28px] md:text-[32px]">
            LEARN • PRACTICE • IMPROVE • LEARN • PRACTICE • IMPROVE • LEARN • PRACTICE • IMPROVE • LEARN • 
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksProduct2;